export const siteNavigation = [
  {
    label: 'Ladies',
    slug: '/ladies/',
    submenu: [
      {
        label: 'Shop Ladies',
        slug: '/ladies/',
      },
      {
        label: 'Apparel',
        submenu: {
          col1: [
            {
              label: 'All',
              slug: '/ladies/collections/apparel/',
            },
            {
              label: 'Capris',
              slug: '/ladies/collections/capris/',
            },
            {
              label: 'Dress',
              slug: '/ladies/collections/dress/',
            },
            {
              label: 'Gloves',
              slug: '/ladies/collections/gloves/',
            },
            {
              label: 'Headwear',
              slug: '/ladies/collections/headwear/',
            },
            {
              label: 'Outerwear',
              slug: '/ladies/collections/wind-rain/',
            },
          ],
          col2: [
            {
              label: 'Pants',
              slug: '/ladies/collections/pants/',
            },
            {
              label: 'Shirts',
              slug: '/ladies/collections/shirts/',
            },
            {
              label: 'Shoes & Socks',
              slug: '/ladies/collections/shoes-socks/',
            },
            {
              label: 'Shorts',
              slug: '/ladies/collections/shorts/',
            },
            {
              label: 'Skirts & Skorts',
              slug: '/ladies/collections/skirts-skorts/',
            },
          ],
        },
      },
      {
        label: 'Brands',
        submenu: {
          col1: [
            // {
            //   label: 'Annika',
            //   slug: '/ladies/collections/annika/',
            // },
            {
              label: 'Abacus',
              slug: '/ladies/collections/abacus/',
            },
            {
              label: 'Bermuda Sands',
              slug: '/ladies/collections/bermuda-sands-brand/',
            },
            {
              label: 'Corsican Golf',
              slug: '/ladies/collections/corsican-golf/',
            },
            // {
            //   label: 'Corsican Sale',
            //   slug: '/ladies/collections/corsican-sale/',
            // },
            {
              label: 'Daily Sports',
              slug: '/ladies/collections/daily-sports/',
            },
            {
              label: "Daphne's Headcovers",
              slug: '/ladies/collections/daphnes-headcovers-brand/',
            },
            // {
            //   label: 'Ecco Shoes',
            //   slug: '/ladies/collections/ecco-shoes/',
            // },
            {
              label: 'Evoke Headwear',
              slug: '/ladies/collections/evoke-headwear/',
            },
            // {
            //   label: 'Fit39 Gloves',
            //   slug: '/ladies/collections/fit39-gloves-brand/',
            // },
            {
              label: 'Glove It',
              slug: '/ladies/collections/glove-it-brand/',
            },
            {
              label: 'Greg Norman',
              slug: '/ladies/collections/greg-norman/',
            },
            {
              label: 'IBKUL',
              slug: '/ladies/collections/ibkul/',
            },
            {
              label: 'Jamie Sadock',
              slug: '/ladies/collections/jamie-sadock-brand/',
            },
          ],
          col2: [
            // {
            //   label: 'Jofit',
            //   slug: '/ladies/collections/jofit-brand/',
            // },
            // {
            //   label: 'Nancy Lopez',
            //   slug: '/ladies/collections/nancy-lopez/',
            // },
            {
              label: 'Navika',
              slug: '/ladies/collections/navika-brand/',
            },
            {
              label: 'Mega Cool Sunshawls',
              slug: '/ladies/collections/mega-cool-sunshawls/',
            },
            {
              label: 'Nivo',
              slug: '/ladies/collections/nivo/',
            },
            {
              label: 'Other Suppliers',
              slug: '/ladies/collections/other-suppliers-brand/',
            },
            {
              label: 'ProQuip',
              slug: '/ladies/collections/proquip-brand/',
            },
            {
              label: 'Radicool',
              slug: '/ladies/collections/radicool/',
            },
            {
              label: 'Red Belly Active',
              slug: '/ladies/collections/red-belly-active/',
            },
            {
              label: 'Skechers Shoes',
              slug: '/ladies/collections/skechers-shoes/',
            },
            {
              label: 'Sporte Leisure',
              slug: '/ladies/collections/sporte-leisure/',
            },
            {
              label: 'Wow! Socks',
              slug: '/ladies/collections/wow-socks/',
            },
          ],
        },
      },
      {
        label: 'Accessories',
        slug: '/ladies/collections/accessories/',
      },
      {
        label: 'Sale',
        slug: '/ladies/collections/clearance-items/',
      },
      {
        label: 'Gift Vouchers',
        slug: '/ladies/collections/gift-certificate/',
      },
    ],
  },
  {
    label: 'Mens',
    slug: '/mens/',
    submenu: [
      {
        label: 'Shop Mens',
        slug: '/mens/',
      },
      {
        label: 'Apparel',
        submenu: {
          col1: [
            {
              label: 'All',
              slug: '/mens/collections/apparel/',
            },
            {
              label: 'Gloves',
              slug: '/mens/collections/gloves/',
            },
            {
              label: 'Headwear',
              slug: '/mens/collections/headwear/',
            },
            {
              label: 'Outerwear',
              slug: '/mens/collections/wind-rain/',
            },
          ],
          col2: [
            {
              label: 'Pants',
              slug: '/mens/collections/pants/',
            },
            {
              label: 'Shirts',
              slug: '/mens/collections/shirts/',
            },
            {
              label: 'Shoes & Socks',
              slug: '/mens/collections/shoes-socks/',
            },
            {
              label: 'Shorts',
              slug: '/mens/collections/shorts/',
            },
          ],
        },
      },
      {
        label: 'Brands',
        submenu: {
          col1: [
            {
              label: 'Bermuda Sands',
              slug: '/mens/collections/bermuda-sands-brand/',
            },
            // {
            //   label: 'Cutter & Buck',
            //   slug: '/mens/collections/cutter-buck/',
            // },
            {
              label: 'Dwyers & Co.',
              slug: '/mens/collections/dwyers-co/',
            },
            // {
            //   label: 'Ecco Shoes',
            //   slug: '/mens/collections/ecco-shoes/',
            // },
            {
              label: 'Evoke Headwear',
              slug: '/mens/collections/evoke-headwear/',
            },
            {
              label: 'Greg Norman',
              slug: '/mens/collections/greg-norman/',
            },
            // {
            //   label: 'Fit39 Gloves',
            //   slug: '/mens/collections/fit39-gloves-brand/',
            // },
            {
              label: 'IBKUL',
              slug: '/mens/collections/ibkul/',
            },
          ],
          col2: [
            {
              label: 'Jamie Sadock',
              slug: '/mens/collections/jamie-sadock-brand/',
            },
            {
              label: 'Other Suppliers',
              slug: '/mens/collections/other-suppliers-brand/',
            },
            // {
            //   label: 'Red Belly Active',
            //   slug: '/mens/collections/red-belly-active/',
            // },
            {
              label: 'ProQuip',
              slug: '/mens/collections/proquip-brand/',
            },
            {
              label: 'Skechers Shoes',
              slug: '/mens/collections/skechers-shoes/',
            },
            {
              label: 'Sporte Leisure',
              slug: '/mens/collections/sporte-leisure/',
            },
            {
              label: 'Travis Mathew',
              slug: '/mens/collections/travis-mathew/',
            },
          ],
        },
      },
      {
        label: 'Accessories',
        slug: '/mens/collections/accessories/',
      },
      {
        label: 'Sale',
        slug: '/mens/collections/clearance-items/',
      },
      {
        label: 'Gift Vouchers',
        slug: '/mens/collections/gift-certificate/',
      },
    ],
  },
  {
    label: 'Home',
    slug: '/',
  },
  {
    label: 'FAQ',
    slug: '/faq/',
  },
  {
    label: 'Blog',
    slug: '/blog/',
  },
  {
    label: 'Contact',
    slug: '/contact/',
  },
];
